// Palette
import palette from '../palette';

export default {
  root: {
    height: '5px',
    backgroundColor: palette.common.black
  }
};
